import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PUBLIC_ROUTE, LAYOUT_ROUTE, NOT_FOUND_ROUTE, SOMETHING_WRONG_ROUTE, LINK_EXPIRED_ROUTE, NO_INTERNET_ROUTE } from './constants/route.constants';
import { PublicGuard, AdminGuard } from './guards';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: LAYOUT_ROUTE.path
    },
    {
        path: PUBLIC_ROUTE.path,
        loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule),
        canLoad: [PublicGuard],
        canActivate: [PublicGuard]
    },
    {
        path: LAYOUT_ROUTE.path,
        loadChildren: () => import('./modules/layout/layout.module').then(m => m.LayoutModule),
        canLoad: [AdminGuard],
        canActivate: [AdminGuard]
    },
    {
        path: NOT_FOUND_ROUTE.path,
        loadChildren: () => import('./modules/not-found/not-found.module').then(m => m.NotFoundModule)
    },
    {
        path: SOMETHING_WRONG_ROUTE.path,
        loadChildren: () => import('./modules/something-wrong/something-wrong.module').then(m => m.SomethingWrongModule)
    },
    {
        path: LINK_EXPIRED_ROUTE.path,
        loadChildren: () => import('./modules/link-expired/link-expired.module').then(m => m.LinkExpiredModule)
    },
    {
        path: NO_INTERNET_ROUTE.path,
        loadChildren: () => import('./modules/no-internet/no-internet.module').then(m => m.NoInternetModule)
    },
    {
        path: '**',
        redirectTo: NOT_FOUND_ROUTE.path
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            { scrollPositionRestoration: 'top' }
        )
    ],
    exports: [RouterModule],
})

export class AppRoutingModule {

}
